export default function offerPriceOptionsResolver({ offer, offerSettings, itemSettings }) {
    return {
        bind: {
            offer,
            currency: offerSettings.currency,
            showOldPrice: itemSettings.showOldPrice !== undefined ? itemSettings.showOldPrice : true,
            showSale: itemSettings.showSale !== undefined ? itemSettings.showSale : true,
        },
    };
}
